export const formatNumber = (value: number, count = 2): number => {
	const multiplayer = Math.pow(10, count);
	return Math.floor(value * multiplayer) / multiplayer;
};


